/* Rriwaayat cart drawer: one-tap "Add" on upsell cards.
   Uses Dawn's own CartDrawer.renderContents() so the drawer and the
   header bag count re-render exactly like a normal add-to-cart. */
(() => {
  if (window.rrCartDrawerReady) return;
  window.rrCartDrawerReady = true;

  // Delegated listener: survives every drawer re-render
  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-rr-add]');
    if (!button) return;
    event.preventDefault();

    const cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer || typeof cartDrawer.renderContents !== 'function') {
      window.location.href = button.dataset.rrUrl;
      return;
    }

    const originalLabel = button.textContent.trim();
    button.classList.remove('is-error');
    button.classList.add('is-loading');
    button.textContent = 'Adding';

    try {
      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      const response = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          id: Number(button.dataset.rrAdd),
          quantity: 1,
          sections: cartDrawer.getSectionsToRender().map((section) => section.id),
          sections_url: window.location.pathname,
        }),
      });
      const state = await response.json();

      if (!response.ok || state.status) {
        throw new Error(state.description || 'Could not add this item');
      }

      cartDrawer.classList.remove('is-empty');
      cartDrawer.renderContents(state);

      if (typeof publish === 'function' && window.PUB_SUB_EVENTS) {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'rr-upsell', cartData: state, variantId: state.variant_id });
      }
    } catch (error) {
      console.error('[rr-cart-drawer]', error);
      button.classList.remove('is-loading');
      button.classList.add('is-error');
      button.textContent = 'Sold out';
      setTimeout(() => {
        button.classList.remove('is-error');
        button.textContent = originalLabel;
      }, 2500);
    }
  });
})();